"use client"

import { HttpTypes } from "@medusajs/types"
import { useState } from "react"
import QuickAddModal from "./quick-add-modal"
import QuickViewModal from "./quick-view-modal"

type ProductCardActionsProps = {
  product: HttpTypes.StoreProduct
  regionId: string
}

// Hover overlay on grid cards: Quick View (mini PDP modal) and Quick Add
// (rapid add + cross-sell chain). Modals mount on first open and stay
// mounted so close transitions play.
export default function ProductCardActions({
  product,
  regionId,
}: ProductCardActionsProps) {
  const [quickViewMounted, setQuickViewMounted] = useState(false)
  const [quickViewOpen, setQuickViewOpen] = useState(false)
  const [quickAddMounted, setQuickAddMounted] = useState(false)
  const [quickAddOpen, setQuickAddOpen] = useState(false)

  if (!product.handle) {
    return null
  }

  return (
    <>
      <div className="pointer-events-none absolute inset-x-0 top-0 aspect-square hidden small:block">
        <div className="absolute inset-x-4 bottom-4 flex items-center gap-x-2 opacity-0 group-hover:opacity-100 focus-within:opacity-100 transition-opacity duration-150">
          <button
            type="button"
            onClick={() => {
              setQuickViewMounted(true)
              setQuickViewOpen(true)
            }}
            aria-label={`Quick view ${product.title ?? "product"}`}
            className="pointer-events-auto flex-1 h-9 rounded-md bg-white/90 border border-gray-200 shadow-sm text-small-regular font-medium text-ui-fg-base hover:bg-white transition-colors"
            data-testid="quick-view-button"
          >
            Quick View
          </button>
          <button
            type="button"
            onClick={() => {
              setQuickAddMounted(true)
              setQuickAddOpen(true)
            }}
            aria-label={`Quick add ${product.title ?? "product"} to cart`}
            title="Quick Add"
            className="pointer-events-auto flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-white/90 border border-gray-200 shadow-sm text-ui-fg-base hover:bg-white transition-colors"
            data-testid="quick-add-button"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 20 20"
              fill="none"
              aria-hidden="true"
            >
              <path
                d="M10 4v12M4 10h12"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </button>
        </div>
      </div>
      {quickViewMounted && (
        <QuickViewModal
          handle={product.handle}
          isOpen={quickViewOpen}
          close={() => setQuickViewOpen(false)}
        />
      )}
      {quickAddMounted && (
        <QuickAddModal
          product={product}
          regionId={regionId}
          isOpen={quickAddOpen}
          close={() => setQuickAddOpen(false)}
        />
      )}
    </>
  )
}
